import { useEffect, useState } from "react";
import Data from "../../data/course_review.json";

import CourseReviewCard from "./components/CourseReviewCard";

function CourseReview() {
  const [filter, setFilter] = useState('all');
  const [dataFirstRow, setDataFirstRow] = useState(Data.first);
  const [dataSecondRow, setDataSecondRow] = useState(Data.second);

  useEffect(() => {
    if (filter !== 'all') {
      const filterDataFirstRow = Data.first.filter(item => item.type === filter)
      const filterDataSecondRow = Data.second.filter(item => item.type === filter)
  
      setDataFirstRow(filterDataFirstRow)
      setDataSecondRow(filterDataSecondRow)
    } else {
      setDataFirstRow(Data.first)
      setDataSecondRow(Data.second)
    }
  }, [filter])

  return (
    <>
      <div className="row mx-auto col-12">
        {/* Mobile-version */}
        <div className="d-md-none row">
          <div className="col-12">
            <button type="button" className={`btn btn-outline-primary btn-block ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>
              All
            </button>
          </div>
          <div className="col-6 d-flex flex-column">
            <button type="button" className={`btn btn-outline-primary btn-block mt-2 ${filter === 'career-transition' ? 'active' : ''}`} onClick={() => setFilter('career-transition')}>
              Career Transition
            </button>
            <button type="button" className={`btn btn-outline-primary btn-block mt-2 ${filter === 'career-gap' ? 'active' : ''}`} onClick={() => setFilter('career-gap')}>
              Career Gap
            </button>
          </div>
          <div className="col-6 d-flex flex-column">
            <button type="button" className={`btn btn-outline-primary btn-block mt-2 ${filter === 'career-upgrade' ? 'active' : ''}`} onClick={() => setFilter('career-upgrade')}>
              Career Upgrade
            </button>
            <button type="button" className={`btn btn-outline-primary btn-block mt-2 ${filter === 'career-launch' ? 'active' : ''}`} onClick={() => setFilter('career-launch')}>
              Career Launch
            </button>
          </div>
        </div>
        {/* -/- Mobile-version */}
        <div className="d-none d-md-block desktop-menu-version">
          <div className="d-flex mb-5">
            <div className="position-relative">
              <button type="button" className={`btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>
                All
              </button>
            </div>
            <div className="position-relative">
              <button type="button" className={`btn ${filter === 'career-transition' ? 'active' : ''}`} onClick={() => setFilter('career-transition')}>
                Career Transition
              </button>
            </div>
            <div className="position-relative">
              <button type="button" className={`btn ${filter === 'career-gap' ? 'active' : ''}`} onClick={() => setFilter('career-gap')}>
                Career Gap
              </button>
            </div>
            <div className="position-relative">
              <button type="button" className={`btn ${filter === 'career-upgrade' ? 'active' : ''}`} onClick={() => setFilter('career-upgrade')}>
                Career Upgrade
              </button>
            </div>
            <div className="position-relative">
              <button type="button" className={`btn ${filter === 'career-launch' ? 'active' : ''}`} onClick={() => setFilter('career-launch')}>
                Career Launch
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="review_scroll_sec pt-4">
        <div className="review_scroll_inner">
          {dataFirstRow.map((data) => (
            <CourseReviewCard {...data} />
          ))}
        </div>
        <div className="review_scroll_inner">
          {dataSecondRow.map((data) => (
            <CourseReviewCard {...data} />
          ))}
        </div>
      </div>
    </>
  );
}
export default CourseReview;
